var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerDefaultPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41 51"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.5 1C9.8 1 1 9.8 1 20.6c0 1.5 0 6 4.3 11.5l.1.1 8.3 9.4.1.1s.3.3.9 1.3c.4.7.9 1.5 1.4 2.4.5.8.9 1.6 1.2 2.2l.5.9v.1c.5 1 1.5 1.6 2.7 1.6 1.1 0 2.2-.6 2.7-1.7l.5-.9c.3-.6.7-1.4 1.2-2.2.5-1 1-1.8 1.4-2.4.6-1 .9-1.3.9-1.3l.1-.1 8.2-9.4s.1-.1.1-.2c4.3-5.6 4.3-10.1 4.3-11.5C40 9.8 31.2 1 20.5 1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20.425c0 1.314 0 4.908 3.668 9.611l8.25 9.3C17.395 40.814 20.5 47 20.5 47s3.106-6.185 4.584-7.665l8.254-9.299C37 25.326 37 21.74 37 20.425 37 11.354 29.613 4 20.5 4S4 11.354 4 20.425Z",
    className: "place_icon_marker_pin_in_stroke"
  })));
}
export default SvgMarkerDefaultPin;